import React from "react"
import NotificationMenu from "./NotificationMenu/NotificationMenu"
import View from "./View/View"
import axios from "axios"
import AxiosConfig from "src/utilities/AxiosConfig"
import Alarm from "./Alarm/Alarm"
import notificationStore from "./notificationStore"
import mutator from "../mutator"
import TaskPrompter from "src/pages/dynamic_forms/TaskPrompter/TaskPrompter"
import "./Notifications.css"
interface Props {
    userId: string | number
}

type State = {
    // notificationMenuOpen: boolean
    notificationsState: any
}

class Notifications extends React.Component<Props, State> {

    wrapperRef: React.RefObject<any>
    interval = 60000

    constructor(props: Props) {
        super(props)
        this.state = {
            // notificationMenuOpen: false,
            notificationsState: notificationStore.state
        }
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this)
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside)
        notificationStore.init(this.interval, this.props.userId)
        //@ts-ignore
        notificationStore.stateWebWorker.addEventListener("message", (event: { data: any }) => {
            this.setState({ notificationsState: event.data })
        })
        this.handleLink()
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside)
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        this.setState(mutator.mutate(this.state, keys))
    }

    handleLink = () => {
        const url = window.location.href
        if (url.includes("new-task")) {
            const notificationId = parseInt(url.split("/")[url.split("/").length - 1])
            axios.get(`${process.env.REACT_APP_API_URL}/api/User/Notification/${notificationId}`, AxiosConfig.configValue("min"))
                .then((res) => {
                    if (res.data.error.success) {
                        notificationStore.manageState([{ key: "openNotification", value: res.data.notification }])
                    }
                })
                .catch(() => {
                    // snackBar({ text: "Failed to fetch notifications.", type: "error", timeout: 2000 })
                })
        }
    }

    handleClickOutside = (event: { target: any }) => {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && this.state.notificationsState.notificationMenuOpen) {
            notificationStore.manageState([{ key: "notificationMenuOpen" }])
        }
    }

    render() {


        const state = this.state
        const props = this.props
        const page = document.getElementById("page-wrapper")

        if (this.state.notificationsState.notificationMenuOpen && page) {
            page.style.opacity = ".7"
        } else if (page) {
            page.style.opacity = "1"
        }

        // //console.log("state", state)

        return (
            <div className="Notifications" ref={this.wrapperRef}>
                <Alarm
                    notificationCount={state.notificationsState.newCount}
                />
                {this.state.notificationsState.notificationMenuOpen &&
                    <NotificationMenu
                        //@ts-ignore
                        notificationsState={props.notificationsState}
                    />}
                {state.notificationsState.openNotification && !state.notificationsState.naggy.shouldNag &&
                    <View
                        notification={state.notificationsState.openNotification}
                        userId={props.userId}
                    />}
                {state.notificationsState.naggy.shouldNag && !state.notificationsState.naggy.error &&
                    <TaskPrompter
                        nags={state.notificationsState.naggy.tasks}
                    />}
            </div>
        )
    }
}

export default Notifications